module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Three")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Two hours after coming back to full consciousness, Chris understood what it was like to be an extra in a B-rated horror flick. He’d already memorized the details of the closetlike cell, even though there was only a single red emergency light overhead, throwing the entire room into dim illumination. Ten feet from the bed to the door. Eleven from the door to the opposite wall. A single plastic chair. A single plastic footstool. A single plastic build-it-yourself wardrobe filled with four sets of the boring white scrubs in which he’d awoken. No metal or sharp edges. All that was missing was padding on the walls and the Joker screaming from down the hall. He circled the room again. It didn’t really make much difference whether this was a prison or an asylum. Neither was particularly appealing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris played with the banal plastic bracelet around his wrist. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Patient 331 PTX.")]), _vm._v(" He didn’t know what PTX meant, and everything felt sinister in the dark red light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He collapsed on his bed, hissing in pain when the rough fabric brushed up against his side. Foul smelling ointment had been smeared on the burn marks left by the Taser, but it wasn’t helping. He rolled over and looked at the door. Every so often—he was willing to bet he could time it and find some sort of pattern—a human silhouette peered inside, though any details were obstructed by the mirror finish. Someone was keeping tabs on him. What were they looking for?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His constant chewing on his lower lip finally drew blood, and he winced as he ran his teeth across the torn skin. When he’d walked into Dr. Peterson’s office, he’d expected questions about his academic integrity and another request to withdraw, not the still-minded woman awaiting him. He’d been tuning out humanity’s wayward, random thoughts for years, and finding someone with such profound silence was staggering. Had he swung that way, he would have propositioned her on the spot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then she’d taken off the damn bracelet. He still couldn’t wrap his mind around the deluge of horrifying images that followed. Blood, people strapped to tables, screaming…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t know where the hell he was. For most of the trip he’d been unconscious. He’d woken occasionally, but all he’d seen was the inside of a windowless van. He hadn’t really come to until after he’d been dumped into the cell. Screaming himself hoarse for the first hour had proved useless. Now he just had to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One of his classmates had been deep into conspiracy theories. The JFK assassination, the Illuminati, water fluoridation…Chris had once spent four hours listening to a sermon about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbey Road")]), _vm._v(" and the death of Paul McCartney. He’d only ever paid attention in an if-I-don’t-supervise-this-person-they’ll-injure-themselves sort of way, but countless rants about faceless government agencies were all flooding back to him. Had some shadowy organization set on exploiting his psychic talents taken him captive?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If someone asks me to point out hidden weapon caches on a map, I’m gonna have a severe freak out.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris sat up and stared at the door. He could try pulling it off its hinges, but the memory of the Taser was still fresh in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It won’t hurt to test things, though.")]), _vm._v(" When he’d first started testing the limits of his bizarre powers, he’d vividly imagined performing feats only seen in movies and cartoons. These days, it was less imagination and more instinct. He concentrated on the door and jerked his mind away from the dull emptiness surrounding the door-shaped area in the wall. He should’ve at least been able to rattle it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris stood and crossed the room to place his hand on the cool metal surface. It reminded him of the woman’s bracelet. He rested his forehead against the door and leaned into it.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They knew about him. So where had they been the past sixteen years?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris dropped back down on the bed again, careful to avoid falling onto his injured side, and curled around one of the flat pillows. Moving the door was out, so he started testing the other walls. The ceiling was made of the same stuff as the door. Touching it brought to mind a huge weight bearing down against him, and he wondered if they were underground. Despite himself, he laughed at the potential cliché. The sound was almost manic. The walls were all the same, and the realization that he was trapped sat like a ball of lead in his stomach. He pushed outward with his mind, trying to find anything resembling a way out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a crack in the metal on the far wall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He jumped off the bed to investigate. The drywall around it had splintered, and something had worn away at the metal beneath it, leaving deep white scratches on the veneer. When he reached out with his mind, he was able to pass through the otherwise impenetrable defenses, and he breathed a sigh of relief. He returned to the bed—he’d figured out early on that unless he wanted to wake up on the floor bent over like a contortionist, it was a better idea to lie down when projecting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t look at his body as his mind stepped away; it was too creepy. Instead, he relied on the elusive feeling of a thin line connecting his mind to his physical form. He could still move his body if he tried, but each second he did drew him back, and he wanted to explore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stepping through wall was like touching water and feeling the barest surface tension before breaking through. He passed through the crack and into the next room. It, as well as the next six, were all empty. Unlike his cell, they were not lined with the weird metal. Had his captors exhausted the budget? The walls were simple drywall and, judging from the cobwebs, they hadn’t been used in a while. Complete silence enfolded him, and he had to imagine the thrum of his heartbeat to keep himself company. He continued onward with shivering certainty that his body was sporting goose bumps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beyond the sixth room he found himself in an empty hallway. Blinding lights glared from overhead, but there was nothing to look at save severe white walls and floor tiles. It was still an improvement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking over his shoulder, Chris mentally tallied the distance he’d traveled from his room. If he went too far, the shadows would become darker, the air colder and a sense of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wrong")]), _vm._v(" would ghost after his steps. He’d only ever gone more than a mile from his body once. He’d suffered from early-onset hypothermia when he’d returned, and for a week afterward felt like he was being watched.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He headed down the hallway, cautiously scanning the corridor for any sign of life. If he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" in some sort of facility meant to contain people who had weird psychic juju, then surely there would be something to stop him from wandering too far.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maybe that’s what the checks are for.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hallways and non-décor reminded him of a hospital. There was something disconcerting about the empty hallways, though it took him a few minutes to realize what. In every hospital he’d ever been in, the sterility had been offset by small things like paintings or commemorative plaques. But here the walls were completely barren. Everything was white, even the doorframes and grid sections holding up the dropped ceiling.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Doors lined both walls, each identical to his, down to the tiny window looking inside each empty room. Crossed-out numbers that had once been in descending order marked faded brass nameplates beside each door. 305…303…301…All had been removed by deep scratches, like someone had taken a knife to the thin metal plating. Had he been tossed into some derelict hospital to rot? No, he’d seen signs of human life, even if it had been just a silhouette.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not alone. Not alone.")]), _vm._v(" The words became like a mantra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tracked the scoring on the nameplates as he passed each room. The violent trail ended at 289. The light was brighter in the cell than the hallway, giving Chris a good look at the man who was inside, lounging on the bed in the same white pajamas. Even with the mental-patient fashion aesthetic, everything about the man spoke of sexuality. Thick auburn hair spilled to his shoulders in gentle waves and framed aristocratic features and bright violet eyes. He was well-muscled, and Chris envied his obvious comfort with his body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris wouldn’t have entertained the thought of approaching him under normal circumstances. Brilliant good looks stood out like a red neon sign blinking Not A Chance. He was balancing an open book on his knees, though he obviously wasn’t reading it. If anything, he struck Chris as being bored, and the mundane expression gave him hope that things weren’t as fucked up as he’d feared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like the others, these walls were easy to pass through. He ventured inward, hoping to get a closer look. It was a little peeping tom, but he couldn’t help wanting to see who else was locked in with him. The man was humming an unrecognizable tune under his breath, soft and surprisingly comforting. Chris gingerly sat on the bed beside him. He’d anticipated that the other man’s body heat would flow into his cool ethereal form and was disappointed by the lingering frost.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, you’re the new patient?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris gasped and leaped to his feet, surprise driving him out of the room and back into the hallway. He stopped a few feet from the door. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Think, Chris. Don’t be an idiot. I can’t be the only one here with some sort of weird power. It makes sense that he can see me. Feel me. Whatever. Maybe I can finally get some answers.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He returned to the room. The man had put the book down beside him and zeroed in on Chris the second he stepped back inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry I startled you. I don’t have a good grasp on what some people refer to as tact.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris mustered up a half smile. “I probably overreacted. No one has ever noticed me when I’m like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man nodded in understanding. “I’m Vance Damascus, affectionately known around here as Patient 289, though I’ll thank you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" to use that particular moniker.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m Chris.” He glanced at Vance’s wristband. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Patient 289. CT2.")]), _vm._v(" “I guess I’m 331. What do they mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What? The gaudy plastic accessories? I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was lying. It was seamless, but Chris could tell anyway. He tried to reach out to poke around in Vance’s mind, and ran into some of the most impressive mental barriers he’d ever encountered. Feeling like an unwelcome intruder, he quickly withdrew. If Vance noticed, he didn’t comment. “Are you like me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vance smirked. “I highly doubt it. But I am possessed of a few talents that resulted in my imprisonment here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris shuddered. “So we are prisoners.” The words were far too final.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Effectively.” Vance patted the spot next to him on the bed. Chris sat beside him, imagining that if he’d been in his body, Vance would have draped an arm across his shoulders. He reached out and passed his hand through Chris’s arm. “I wish I could see you. I can feel you. I know where you’re standing. But you’re little more than a voice in my head. It frightens me to think I’m losing what mental faculties I have remaining.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose me trying to tell you you’re not going crazy isn’t going to help. At least, not if you think I’m your delusional creation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I do have the utmost faith in myself, so if you were a product of my imagination, I could allow myself to be reassured.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris grinned. “I’ll roll with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then you’re definitely not a delusion. I’m a very skeptical man. Astral projection certainly allows you more freedom than I have. Any other goodies in your repertoire?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris hesitated to give the man a laundry list, and the comic-book names for his powers always seemed so phony. “A few. You?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know a trick or two. When were you admitted?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A few hours ago, I think. I haven’t seen any clocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One of the patients went insane and stabbed an orderly with a torn-off minute hand. Apparently the ticking did him in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris’s jaw dropped in horror. “Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This place gets to everyone eventually.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Couldn’t tell you. I spent my own incarceration mostly unconscious. What I do know is that this place houses oddities. I’d call it a museum, but they don’t take very good care of the exhibits.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How many?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Three bodies, now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something about the way Vance worded it sent a spike of dread coiling through him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The majority of the people here have been subdued by a combination of drugs and neglect. The refuge of their minds is preferable to the reality around them.” Vance sniffed. “Wish I had that luxury.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s not very comforting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not meant to be. If you want to survive, Chris, downplay what you can do. Feign a few minor powers and swallow the drugs they push on you. Even if they don’t have any effect, pretend they do. Give her no indication that you’re anything more than a man with a handful of quirks that sets him apart from the rest of the population.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why are you telling me this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve had enough of Dr. Dalhousie and her slack-jawed peons pushing people around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris caught the barest glimpse of an ugly thought flitting through Vance’s mind. It was gone quickly and Chris couldn’t have put the impression to words if he’d tried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Besides, it works to my benefit. If the first dose doesn’t completely knock out your powers, it’ll give me someone to talk to. Trying to engage in decent conversation in this place is tantamount to laughing at a funeral.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Strongly discouraged?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To say the least.” Vance offered him a smile. “If you were just admitted, they’ll probably come around to perform an introductory examination soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris grimaced. “I don’t like the sound of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll like the tests a lot less.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris felt an echo along the line that led back to his body. Someone was shaking him. He looked helplessly at Vance. “I think they’ve come for me.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His sympathy was easy to read.")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2e62d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426890574_ch03.vue
// module id = 87
// module chunks = 0